import { DropdownItem } from '@view/shared/molecules/dropdown/dropdown.component';

export function formatBirthDate(
  birthDateValue: string | Date | undefined
): string {
  if (!birthDateValue) {
    return '';
  }

  if (typeof birthDateValue === 'string') {
    return birthDateValue.includes('T')
      ? birthDateValue.split('T')[0]
      : birthDateValue;
  }

  const dateObj = new Date(birthDateValue);
  const year = dateObj.getFullYear();
  const month = String(dateObj.getMonth() + 1).padStart(2, '0');
  const day = String(dateObj.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function mapToDropdownItems<T extends { name: string }>(
  items: T[],
  valueField: keyof T = 'id' as keyof T
): DropdownItem[] {
  return items.map((item) => ({
    label: item.name,
    value: String(item[valueField])
  }));
}

export const FORM_FIELDS = {
  ID_NUMBER: 'idNumber',
  IDENTIFIER_TYPE: 'identifierType',
  GIVEN_NAME: 'givenName',
  MIDDLE_NAME: 'middleName',
  FAMILY_NAME: 'familyName',
  MATERNAL_FAMILY_NAME: 'maternalFamilyName',
  EMAIL_ADDRESS: 'emailAddress',
  BIRTH_DATE: 'birthDate',
  ADMINISTRATIVE_SEX: 'administrativeSex',
  MARITAL_STATUS: 'maritalStatus',
  RACE: 'race',
  TELEPHONE_NUMBER: 'telephoneNumber',
  STREET_ADDRESS: 'streetAddress',
  CITY: 'city',
  STATE: 'state',
  BIRTH_COUNTRY: 'birthCountry',

  SPECIMEN_ID: 'specimenId',
  SPECIMEN_TYPE: 'specimenType',
  SPECIMEN_CONTAINER_ID: 'specimenContainerId',
  PRIORITY_ID: 'priorityId',
  IS_REPROCESS: 'isReprocess',

  EXAM_TYPE: 'examType',

  COMPANY_ID: 'companyId',
  PROVIDER_ID: 'providerId',
  REGIONAL: 'regional',
  SITE: 'site',
  PLACER_ORDER_NUMBER: 'placerOrderNumber',
  CONSENT_FOR_USE_OF_SAMPLES: 'consentForUseOfSamples',
  USER_DATA_DESCRIPTION: 'userDataDescription',
  DESCRIPTION_DATA_SAMPLE: 'descriptionDataSample',
  DESCRIPTION_DATA_EXAM: 'descriptionDataExam',
  CLINICAL_HISTORY: 'clinicalHistory',
  PRIORITIZATION: 'prioritization',
  ACMG: 'acmg',
  MLPA: 'mlpa',
  LABORATORIES_ID: 'laboratoriesId',
  DIAGNOSES_ID: 'diagnosesId',
  SPECIALISTS_ID: 'specialistsId',

  CAUSE_REPROCESS_ID: 'causeReprocessId',
  STATUS_REPROCESS_ID: 'statusReprocessId',
  REPROCESS_DESCRIPTION: 'reprocessDescription'
} as const;

export const IDENTIFIER_TYPE_OPTIONS: DropdownItem[] = [
  { label: 'CC', value: 'CC' },
  { label: 'TI', value: 'TI' },
  { label: 'CE', value: 'CE' },
  { label: 'PA', value: 'PA' }
];

export const ADMINISTRATIVE_SEX_OPTIONS: DropdownItem[] = [
  { label: 'Masculino', value: 'M' },
  { label: 'Femenino', value: 'F' },
  { label: 'Otro', value: 'O' }
];

export function toStringOrNull(value: any): string | null {
  return value ? String(value) : null;
}
